import {Key, useEffect, useRef, useState} from 'react';
import {wdiCore, WdiModalAppProps} from '@/components/WdiControls';
import {HorzLayoutOpts, WdiModalForm} from '@/components/WdiControls/WdiModalForm';
import {ProFormInstance} from '@ant-design/pro-form';
import {message} from 'antd';
import {ColumnsType} from 'antd/lib/table';
import {WdiTable} from '@/components/WdiControls/WdiTable';
import {Invoices} from '@/services/sales/financial/invoices';
import {ResponseStatus} from '@/utils/request';

const QuoteInvoiceApp: React.FC<WdiModalAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState<API.InvoiceVo[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<Key[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const {data} = props;

  const columns: ColumnsType<any> = [
    {
      title: '发票号码',
      width: 150,
      dataIndex: 'invoiceNo',
      ellipsis: true,
    },
    {
      title: '发票代码',
      width: 150,
      dataIndex: 'invoiceCode',
      ellipsis: true,
    },
    {
      title: '发票日期',
      dataIndex: 'invoiceDate',
      width: 150,
      ellipsis: true,
      render: (_, record) => (
        wdiCore.Date.DateToString(record.invoiceDate)
      ),
    },
    {
      title: '发票金额(含税)',
      width: 120,
      dataIndex: 'amountInVat',
      ellipsis: true
    },
    {
      title: '发票税金',
      width: 120,
      dataIndex: 'tax',
      ellipsis: true
    },
    {
      title: '发票可用金额(含税)',
      dataIndex: 'amountNotPaid',
      width: 120,
      ellipsis: true,
    },
    {
      title: '发票可用税金',
      dataIndex: 'taxNotPaid',
      width: 120,
      ellipsis: true,
    },
  ];

  useEffect(() => {
    if (data) {
      fetchData();
    }
  }, [data]);

  const fetchData = () => {
    setLoading(true);
    setSelectedRowKeys([]);
    setSelectedRows([]);
    Invoices.quoteInvoice({
      vatTypeId: data?.vatType?.vatTypeId,
      invoiceMakerCode: data?.invoiceMakerCode,
      supplierId: data?.supplierId,
      soldToCode: data?.soldToCode,
      companyCode: data?.companyCode,
      payToUserId: data?.payToUserId,
    }).then(responseResult => {
      setDataSource(responseResult.data);
      setLoading(false);
    });
  };

  const onSelectChange = (newSelectedRowKeys: Key[], selectedRows: any[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(selectedRows);
  };
  return (
    <>
      <WdiModalForm
        formRef={formRef}
        {...HorzLayoutOpts}
        title={props.title}
        visible={props.visible}
        modalProps={{
          onCancel: () => {
            props.onClose ? props.onClose() : null
          },
          width: 1200,
          bodyStyle: {height: 460}
        }}
        onFinish={async (values) => {
          if (selectedRowKeys.length == 0) {
            message.error('请至少选择一条数据');
          } else {
            if (props.onSave) {
              props.onSave({
                code: ResponseStatus.SUCCESS,
                data: selectedRows
              })
            }
          }
        }}
      >
        <WdiTable
          columns={columns}
          showPageRows={10}
          rowKey="invoiceId"
          dataSource={dataSource}
          pagination={false}
          loading={loading}
          rowSelection={{selectedRowKeys, onChange: onSelectChange}}
        />
      </WdiModalForm>
    </>
  );
};
export default QuoteInvoiceApp;
